'use client';

export default function FindEventsPageSkeleton() {
  return (
    <div style={{ minHeight: '100vh', width: '100%', background: '#f8f9fa' }}>
      {/* Banner Skeleton */}
      <div style={{ 
        height: '400px', 
        background: 'linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%)',
        backgroundSize: '200% 100%',
        animation: 'shimmer 1.5s infinite',
      }} />
      
      {/* Content Skeleton */}
      <div className="container py-5">
        <div className="row g-4">
          {[1, 2, 3, 4, 5, 6].map(i => (
            <div key={i} className="col-lg-4 col-md-6">
              <div style={{
                height: '400px',
                background: 'linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%)',
                backgroundSize: '200% 100%',
                animation: 'shimmer 1.5s infinite',
                borderRadius: '8px',
              }} />
            </div>
          ))}
        </div>
      </div>
      
      <style jsx>{`
        @keyframes shimmer {
          0% { background-position: -200% 0; }
          100% { background-position: 200% 0; }
        }
      `}</style>
    </div>
  );
}

